import { bindable, computedFrom } from 'aurelia-framework';
import { IImportMappingErrorAM } from './import-api';

export class ImportMappingErrors {
	@bindable errors: IImportMappingErrorAM[];
	@bindable successText: string;
	@bindable errorParameters: string[];

	@computedFrom('errors')
	get errorItems() {
		return this.errors != null
			? this.errors.map(error => new ErrorItem(error))
			: null;
	}

	@computedFrom('errors')
	get hasErrors() {
		return (this.errors != null && this.errors.length > 0);
	}
}

class ErrorItem {
	constructor(public error: IImportMappingErrorAM) {
	}

	@computedFrom('error')
	get errorClass() {
		if (this.error == null) {
			return '';
		}

		switch (this.error.severity) {
			case 'Warning':
				return 'text-warning';
			case 'Error':
				return 'text-danger';
			default:
				throw new Error(`Severity ${this.error.severity} is invalid.`);
		}
	}
}
